import * as ReactService from "@intech/react-service";

class Formularios extends ReactService.BaseService {
  constructor() {
    super("Formularios");
  }

  GetRelatorioAdesaoContratoAberturaCredito = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioAdesaoContratoAberturaCredito/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GetRelatorioAlteracaoPercentualPlanoB = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioAlteracaoPercentualPlanoB/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GetRelatorioAtualizacaoDadosBancarios = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioAtualizacaoDadosBancarios/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GetRelatorioDeclaracaoDeDepedencia = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioDeclaracaoDeDepedencia/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GetRelatorioDesignicaoBeneficiarioParticipanteAdmitido = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioDesignicaoBeneficiarioParticipanteAdmitido/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GetRelatorioInclusaoExclusaoPensaoPorMorte = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioInclusaoExclusaoPensaoPorMorte/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  GetRelatorioSolicitacaoEmprestimo = (enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioSolicitacaoEmprestimo/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const FormulariosService = new Formularios();
